import postal from 'postal';

export default function bootstrap() {
  $(() => {
    // NOTE checkbox groups
    $(document).on('click', '.btn-group label.btn input[type=checkbox]', event => {
      const $target = $(event.currentTarget);

      if ($target.is(':checked')) {
        $target.parents('label.btn')
          .addClass('btn-secondary')
          .removeClass('btn-default');
      } else {
        $target.parents('label.btn')
          .removeClass('btn-secondary')
          .addClass('btn-default');
      }
    });

    // NOTE radio button groups
    $(document).on('click', '.btn-group label.btn input[type=radio]', event => {
      const $target = $(event.currentTarget);

      $target.parents('.btn-group').children('label.btn-secondary')
        .removeClass('btn-secondary')
        .addClass('btn-default');
      $target.parents('label.btn')
        .addClass('btn-secondary')
        .removeClass('btn-default');
    });

    // NOTE Add 'data-postal-channel' and 'data-postal-topic' tags to a clickable
    // element to get it to send a message via postal on click
    $(document).on('click', '[data-postal-channel]', event => {
      if (event && event.preventDefault) {
        event.preventDefault();
      }

      const $target = $(event.currentTarget);
      const channel = $target.data('postal-channel');
      const topic = $target.data('postal-topic');

      postal.publish({
        channel,
        topic,
      });

      return false;
    });
  });
}
